import type { MotifTheme } from '@/motif/setup';

// Footer legal links — legacy `environment.privacyLink` / `environment.termsOfUse`
// (identical across envs today, but env-driven for parity + per-env control).
const PRIVACY_LINK =
  import.meta.env.VITE_PRIVACY_LINK || 'https://www.ey.com/en_us/privacy-statement';
const TERMS_OF_USE =
  import.meta.env.VITE_TERMS_OF_USE || 'https://www.ey.com/en_us/legal-and-privacy';

interface ShellFooterProps {
  theme?: MotifTheme;
  onToggleTheme?: () => void;
}

export function ShellFooter({ theme, onToggleTheme }: ShellFooterProps) {
  const showThemeToggle = theme && onToggleTheme;

  return (
    <footer className="shell-footer" data-test-id="footer">
      <div className="shell-footer__copyrights">
        <span className="material-symbols-outlined shell-footer__icon">copyright</span>
        <span className="shell-footer__text">
          Copyright {new Date().getFullYear()} EYGM Limited | All Rights Reserved | Content within
          this application is confidential and meant for EY staff and EY clients only. Please review
          the{' '}
          <a className="shell-footer__link" href={PRIVACY_LINK} target="_blank" rel="noopener">
            Privacy Notice
          </a>{' '}
          and{' '}
          <a className="shell-footer__link" href={TERMS_OF_USE} target="_blank" rel="noopener">
            Terms of Use
          </a>{' '}
          for additional information.
        </span>
      </div>
      <p className="shell-footer__disclaimer">
        Please do not enter any unnecessary personal information or any sensitive personal data
        (including government identifiers such as tax file numbers or social security numbers),
        client confidential information, audit secrets, state secrets, commercial secrets, or
        anything that would violate professional secrecy or confidentiality rules or that would be
        considered abusive/irrelevant.
      </p>
      {showThemeToggle ? (
        <button type="button" className="shell-footer__theme" onClick={onToggleTheme}>
          Theme: {theme === 'light' ? 'Light' : 'Dark'}
        </button>
      ) : null}
    </footer>
  );
}
